import { createContext } from 'react';

import { FormatterWithPrecision } from '../../core/types/formatter.js';

export const HoneycombTickFormatter = createContext<
  FormatterWithPrecision | undefined
>(undefined);
